<template>
  <div>
    <hr
      class="hr-text"
      data-content="Danh mục sản phẩm"
      style="font-weight: 600"
    />
    <Categories
      @category-selected="handleCategorySelected"
      :categories="stockCheckSheet.categories"
    />
    <hr class="hr-text" :data-content="dataContent" style="font-weight: 600" />
    <div class="mb-5">
      <b-row class="mb-3">
        <b-col md="3">
          <b-form-select
            v-model="selectTypeSearch"
            class="select-style"
            :options="listTypeSearch"
            size="sm"
            value-field="id"
            text-field="name"
            @change="changePlaceholder"
          ></b-form-select>
        </b-col>
        <b-col md="6">
          <b-form-input
            size="sm"
            v-model="textSearchProduct"
            @input="onInputChangeProduct"
            class="autosuggest__input"
            @keyup.enter="onFilter()"
            :placeholder="inputPlaceHolder"
          >
            <template slot-scope="{ suggestion }">
              <div>{{ suggestion.item.productName }}</div>
            </template>
          </b-form-input>
        </b-col>
        <b-col md="3">
          <b-form-select
            v-model="selectTypeFilter"
            class="select-style"
            :options="listTypeFilter"
            size="sm"
            value-field="id"
            text-field="name"
            @change="handleChangeSelectTypeFilter"
          ></b-form-select>
        </b-col>
      </b-row>
    </div>
    <b-row class="mb-5">
      <b-col> </b-col>
      <b-col>
        <div class="d-flex d-inline justify-content-end mb-4">
          <span class="mr-2">
            <i class="fas fa-circle fa-sm text-dark"></i>
            Tồn có thể bán
          </span>
          <span class="mr-2">
            <i class="fas fa-circle fa-sm text-warning"></i>
            Đang giữ hàng
          </span>
          <span class="mr-2">
            <i class="fas fa-circle fa-sm text-primary"></i>
            Đang bảo hành
          </span>
          <span class="mr-2">
            <i class="fas fa-circle fa-sm text-danger"></i>
            Tồn lỗi
          </span>
        </div>
      </b-col>
    </b-row>
    <b-table ref="top" :items="items" :fields="fieldsComputed" :busy="isBusy">
      <template v-slot:head(imei)>
        <div class="d-flex align-items-center">
          <span class="mr-2">IMEI</span>
          <i
            class="fas fa-info-circle text-muted"
            v-b-tooltip.hover.top
            title="Nhập IMEI, mỗi dòng một IMEI"
            style="font-size: 1rem"
          ></i>
        </div>
      </template>
      <template v-slot:table-busy>
        <vcl-table :speed="5" :animate="true" :columns="10"></vcl-table>
      </template>
      <template v-slot:cell(no)="data">{{
        setIndexTable(data.item.index)
      }}</template>
      <template v-slot:cell(barCode)="data">
        <div v-if="data.item.barCode !== ''">
          <div style="display: flex; gap: 8px; align-items: center">
            <!-- Ảnh sản phẩm -->
            <ProductImage :src="data.item.productImageUrl" />

            <!-- Thông tin sản phẩm -->
            <div>
              <span style="font-size: 11px">{{ data.item.barCode }}</span>
              <br />
              <span style="font-size: 12px">({{ data.item.productCode }})</span>
              <br />
              <p class="m-0" style="font-weight: 500">
                {{ data.item.productName }}
              </p>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:cell(imei)="data">
        <div
          v-if="data.item.productType === PRODUCT_TYPE.PRODUCT_IMEI"
          class="imei-input-container"
        >
          <b-form-textarea
            :disabled="data.item.productType !== PRODUCT_TYPE.PRODUCT_IMEI"
            size="sm"
            v-model="data.item.realImeiNos"
            @keyup="onImeiInput(data.index, data.item.realImeiNos)"
            class="imei-textarea"
            rows="3"
            placeholder="Nhập IMEI..."
          ></b-form-textarea>
        </div>
        <span v-else class="text-muted">-</span>
      </template>
      <template v-slot:cell(stockInfo)="data">
        <div
          style="text-align: center"
          v-if="checkPermissions(['STOCK_CHECK_VIEW_DETAIL'])"
        >
          <b
            v-text="data.item.inStockQuantity"
            class="mr-1"
            v-b-tooltip.hover.bottom
            title="Tổng tồn có thể bán"
          ></b>
          <b
            class="text-primary mr-1 font-size-setting"
            v-if="data.item.warrantyQuantity > 0"
            v-b-tooltip.hover.bottom
            title="Tổng đang bảo hành"
          >
            {{ '+ ' + data.item.warrantyQuantity }}
          </b>
          <b
            class="text-warning font-size-setting"
            v-if="data.item.holdingQuantity > 0"
            v-b-tooltip.hover.bottom
            title="Tổng đang giữ hàng"
          >
            {{ '+ ' + data.item.holdingQuantity }}
          </b>
          <b
            class="text-danger font-size-setting"
            v-if="data.item.errorQuantity > 0"
            v-b-tooltip.hover.bottom
            title="Tồn lỗi"
          >
            {{ '+ ' + data.item.errorQuantity }}
          </b>
        </div>
      </template>
      <template v-slot:cell(realQuantity)="data">
        <b-form-input
          v-if="!isConfirmed"
          v-model="data.item.realQuantity"
          :disabled="data.item.productType === PRODUCT_TYPE.PRODUCT_IMEI"
          type="number"
          min="0"
          @input="markPendingChange(data.item)"
        >
        </b-form-input>
        <span v-else>{{ data.item.realQuantity }}</span>
      </template>
      <template v-slot:cell(stateName)="data">
        <span
          :class="checkClassStateName(data.item.stateName)"
          class="font-weight-bold"
        >
          {{ data.item.stateName }}
          <span v-if="data.item.stockInfo">{{ data.item.stockInfo }}</span>
        </span>
      </template>
      <template v-slot:cell(imeiNos)="data">
        <div class="imei-system-container">
          <div
            v-for="imeiNo in getDisplayedImeis(data.item)"
            :key="`${data.item.id}-${imeiNo}-${forceUpdate}`"
            :class="getClassForImei(imeiNo, data.item.realImeiNos)"
            class="imei-item"
          >
            {{ imeiNo }}
          </div>
          <div
            v-if="data.item.imeiNos.length > 3"
            class="text-muted cursor-pointer"
            @click="toggleImeiVisibility(data.index)"
          >
            <small>
              <i
                :class="
                  isImeiExpanded(data.index)
                    ? 'fas fa-chevron-up'
                    : 'fas fa-ellipsis-h'
                "
                class="mr-1"
              ></i>
              <span v-if="!isImeiExpanded(data.index)">
                +{{ data.item.imeiNos.length - 3 }} IMEI khác
              </span>
              <span v-else> Thu gọn </span>
            </small>
          </div>
        </div>
      </template>
      <template v-slot:cell(action)="data">
        <div class="d-flex justify-content-center">
          <b-dropdown size="sm" id="dropdown-left" no-caret right>
            <template slot="button-content">
              <i
                style="font-size: 1rem; padding-right: 0px"
                class="flaticon2-settings"
              ></i>
            </template>
            <b-dropdown-item
              v-if="!isConfirmed"
              @click="upsertStockCheckProduct(data.item)"
            >
              <span style="color: #3f4254; font-size: 12px">
                <i
                  style="font-size: 1rem"
                  class="fas fa-plus-circle text-success"
                ></i>
                &nbsp; Thêm sản phẩm
              </span>
            </b-dropdown-item>

            <b-dropdown-item @click="showNoteModal(data.item)">
              <span style="color: #3f4254; font-size: 12px">
                <i style="font-size: 1rem" class="fas fa-pen text-info"></i>
                &nbsp; Thêm ghi chú
              </span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="checkPermissions(['STOCK_CHECK_VIEW_DETAIL'])"
              @click="showHistoryModal(data.item.id)"
            >
              <span style="color: #3f4254; font-size: 12px">
                <i class="fas fa-history text-info"></i>
                &nbsp; Lịch sử
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </b-table>
    <b-row class="d-flex justity-content-center">
      <b-col>
        <p class="mt-3 text-dark" style="font-weight: 500">
          Tổng số :
          {{ totalItem }}
        </p>
      </b-col>
      <b-col>
        <BPaginationNavCustom
          :number-of-pages="numberOfPage || 1"
          :current-page="currentPage"
          :total-page="numberOfPage"
          :linkParams="{ id: this.stockCheckSheet.id }"
          @page-change="fetchProductByCategory()"
        >
        </BPaginationNavCustom>
      </b-col>
    </b-row>
    <div class="sticky-action-bar">
      <slot></slot>
    </div>
    <template>
      <InventoryCheckHistory
        ref="inventory-check-history"
        :stockCheckProductLogs="stockCheckProductLogs"
      />
    </template>
    <InventoryCheckNoteModal
      v-if="stockCheckSheet.id"
      ref="note-modal"
      :stockCheckSheetId="stockCheckSheet.id"
      @note-saved="handleNoteSaved"
    />
  </div>
</template>

<script>
import {
  STOCK_CHECK_SHEET_STATUS,
  PRODUCT_TYPE,
  STOCK_CHECK_PRODUCT_LOG_SOURCE_TYPE,
  STOCK_CHECK_PRODUCT_SEARCH_TYPE,
} from '@/utils/enum';
import ApiService from '@/core/services/api.service';
import { TIME_TRIGGER } from '@/utils/constants';
import Categories from '@/view/components/inventoryCheck/Categories.vue';
import { makeToastSuccess } from '@/utils/common';
import debounce from 'lodash/debounce';
import { handleError } from '../../../utils/common';
import InventoryCheckHistory from '@/view/components/inventoryCheck/inventory-history-modal.vue';
import InventoryCheckNoteModal from '@/view/components/inventoryCheck/InventoryCheckNoteModal.vue';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';
import vclTable from 'vue-content-loading';
import ProductImage from '@/view/components/products/ProductImage.vue';
import permissionMixin from '@/view/mixins/permission.mixin';

export default {
  mixins: [permissionMixin],
  props: {
    stockCheckSheetData: {
      type: Object,
    },
  },
  watch: {
    $props: {
      handler(newVal) {
        this.stockCheckSheet = newVal.stockCheckSheetData;
        this.isConfirmed =
          this.stockCheckSheet.status !== STOCK_CHECK_SHEET_STATUS.NEW;
        this.selectedCategoryId = this.stockCheckSheet.categories[0]?.id;
        this.fetchProductByCategory();
        this.handleSearchType(this.stockCheckSheet.productType);
        this.configureFieldsForPermission();
      },
      deep: true,
      immediate: false,
    },
  },
  data() {
    return {
      PRODUCT_TYPE,
      STOCK_CHECK_SHEET_STATUS,
      STOCK_CHECK_PRODUCT_SEARCH_TYPE,
      items: [],
      textSearchProduct: '',
      inputPlaceHolder: 'Tìm kiếm theo tên, mã, mã vạch sản phẩm',
      dataContent: 'Danh sách sản phẩm',
      selectTypeSearch: STOCK_CHECK_PRODUCT_SEARCH_TYPE.PRODUCT_NAME,
      selectTypeFilter: 'ASC',
      linkGen: (pageNum) => {
        return pageNum === 1
          ? `?id=${this.stockCheckSheet.id}`
          : `?id=${this.stockCheckSheet.id}&page=${pageNum}`;
      },
      listTypeSearch: [
        {
          id: STOCK_CHECK_PRODUCT_SEARCH_TYPE.PRODUCT_NAME,
          name: 'Tìm sản phẩm',
        },
        {
          id: STOCK_CHECK_PRODUCT_SEARCH_TYPE.PRODUCT_IMEI,
          name: 'Tìm sản phẩm IMEI',
        },
        {
          id: STOCK_CHECK_PRODUCT_SEARCH_TYPE.BARCODE_SCANNER,
          name: 'Máy quét mã vạch',
        },
      ],
      listTypeFilter: [
        {
          id: 'DESC',
          name: 'Sắp xếp theo: kiểm kê đủ',
        },
        {
          id: 'ASC',
          name: 'Sắp xếp theo: kiểm kê thiếu',
        },
      ],
      totalItem: 0,
      limit: 10,
      numberOfPage: 1,
      currentPage: this.$route.query.page || 1,
      stockCheckSheet: { status: 1, productType: null, categories: [] },
      searchProduct: '',
      searchProductImei: '',
      fields: [
        {
          key: 'no',
          label: 'STT',
          tdClass: 'text-center align-middle',
          thClass: 'text-center align-middle',
          thStyle: { width: '5%' },
        },
        {
          key: 'barCode',
          label: 'Sản phẩm',
          sortable: false,
          thStyle: { width: '30%' },
          tdClass: 'text-left align-middle',
          thClass: 'text-center align-middle',
        },
        {
          key: 'imei',
          label: 'IMEI',
          sortable: false,
          thStyle: { width: '20%' },
          tdClass: 'text-left align-middle',
          thClass: 'text-center align-middle',
        },
        {
          key: 'imeiNos',
          label: 'IMEI hệ thống',
          sortable: false,
          thStyle: { width: '15%' },
          tdClass: 'text-left align-middle',
          thClass: 'text-center align-middle',
        },
        {
          key: 'stockInfo',
          label: 'Tồn kho',
          tdClass: 'text-center align-middle',
          thClass: 'text-center align-middle',
          thStyle: { width: '10%' },
        },
        {
          key: 'realQuantity',
          label: 'Số lượng',
          thClass: 'text-center align-middle',
          tdClass: 'text-center align-middle',
          thStyle: { width: '10%' },
        },
        {
          key: 'stateName',
          label: 'Tình trạng',
          thClass: 'text-center align-middle',
          tdClass: 'text-center align-middle',
          thStyle: { width: '10%' },
        },
        {
          key: 'action',
          label: 'Hành động',
          tdClass: 'text-center align-middle',
          thClass: 'text-center align-middle',
        },
      ],
      selectedCategoryId: null,
      isBusy: false,
      isConfirmed: true,
      stockCheckProductLogs: [],
      expandedImeiRows: {},
      forceUpdate: 0,
      pendingChanges: {},
    };
  },
  methods: {
    async showHistoryModal(id) {
      try {
        const {
          data: { data },
        } = await ApiService.query(`v1/stock-check-product/${id}/histories`);
        this.stockCheckProductLogs = data;
        this.$refs['inventory-check-history'].showModal();
      } catch (err) {
        handleError(err);
      }
    },
    handleChangeSelectTypeFilter(item) {
      this.selectTypeFilter = item;
      this.fetchProductByCategory();
    },
    handleSearchType(productType) {
      this.selectTypeSearch =
        productType || STOCK_CHECK_PRODUCT_SEARCH_TYPE.PRODUCT_NAME;
      this.changePlaceholder();
    },
    //TODO
    configureFieldsForPermission() {
      const hasPermissionViewDetail = this.checkPermission(
        'STOCK_CHECK_VIEW_DETAIL',
      );
      if (
        !hasPermissionViewDetail ||
        this.stockCheckSheet.productType === PRODUCT_TYPE.PRODUCT
      ) {
        this.fields = this.fields.filter((field) => field.key !== 'imeiNos');
      }
    },
    onImeiInput(index, value) {
      let countLine = 0;
      const tmp = value.split(/\r\n|\r|\n/);
      tmp.forEach((element) => {
        if (element.trim() !== '') {
          countLine++;
        }
      });
      this.items[index].realQuantity = countLine;
      this.markPendingChange(this.items[index]);
    },
    markPendingChange(item) {
      this.pendingChanges[item.id] = {
        id: item.id,
        productId: item.productId,
        realQuantity: Number(item.realQuantity),
        realImeiNos: item.realImeiNos,
        version: item.version || 0,
        productOutside: item.productOutside,
        productType: item.productType,
        stockCheckCategoryId: this.selectedCategoryId,
        dirty: true,
      };
    },
    _snapshotCurrentItems() {
      this.items.forEach((item) => {
        if (!item.id) return;
        const existing = this.pendingChanges[item.id];
        this.pendingChanges[item.id] = {
          id: item.id,
          productId: item.productId,
          realQuantity: Number(item.realQuantity),
          realImeiNos: item.realImeiNos,
          version: item.version || existing?.version || 0,
          productOutside: item.productOutside,
          productType: item.productType,
          stockCheckCategoryId: this.selectedCategoryId,
          dirty: existing?.dirty || false,
        };
      });
    },
    async saveAllPendingChanges() {
      const dirtyList = Object.values(this.pendingChanges).filter((p) => p.dirty);
      if (!dirtyList.length) return true;
      try {
        const products = dirtyList.map((pending) => ({
          id: pending.id,
          productId: pending.productId,
          realQuantity: pending.realQuantity,
          realImeiNos:
            pending.productType === PRODUCT_TYPE.PRODUCT_IMEI
              ? String(pending.realImeiNos || '')
                  .split(/\r\n|\r|\n|,/)
                  .map((x) => x.trim())
                  .filter(Boolean)
              : [],
          version: pending.version,
          productOutside: pending.productOutside,
        }));

        const {
          data: { data: updatedProducts },
        } = await ApiService.put('/v1/stock-check-product/bulk-update-cart', {
          stockCheckSheetId: this.stockCheckSheet.id,
          sourceType: STOCK_CHECK_PRODUCT_LOG_SOURCE_TYPE.WEB_MANUAL,
          products,
        });
        updatedProducts.forEach((updated) => {
          const found = this.items.find(({ id }) => id === updated.id);
          if (found) {
            found.version = updated.version;
            found.realQuantity = updated.realQuantity;
            found.realImeiNos = this.convertImeiToString(updated.realImeiNos);
            found.stateName = updated.stateName;
            found.stockInfo = updated.stockInfo;
          }
        });
        this.pendingChanges = {};
        return true;
      } catch (err) {
        handleError(err);
        return false;
      }
    },
    setIndexTable(index) {
      const currentPage = this.$route.query.page || 1;
      return (currentPage - 1) * this.limit + index;
    },
    backToProductByCate() {
      this.$router
        .push({
          name: 'upsert-inventory-check',
          query: { id: this.stockCheckSheet.id },
        })
        .catch(() => {});
      this.fetchProductByCategory();
    },
    checkClassStateName(stateName) {
      if (stateName === 'Đủ') {
        return 'badge badge-success';
      }
      if (stateName === 'Lệch') {
        return 'text-danger';
      }
      if (stateName === 'Mới') {
        return 'badge badge-light';
      }
      if (stateName === 'SP bên ngoài') {
        return 'badge badge-warning';
      }
    },
    mappingStockCheckProductModel(product) {
      const realImeiNos =
        product.productType === PRODUCT_TYPE.PRODUCT_IMEI
          ? product.realImeiNos.split(/\r\n|\r|\n|,/).map((item) => item.trim())
          : [];
      return {
        id: product?.id,
        productId: product.productId,
        stockCheckSheetId: this.stockCheckSheet.id,
        stockCheckCategoryId: this.selectedCategoryId,
        realImeiNos,
        realQuantity: Number(product.realQuantity),
        version: product.version || 0,
        productOutside: product.productOutside,
      };
    },
    async upsertStockCheckProduct(product) {
      try {
        const body = {
          ...this.mappingStockCheckProductModel(product),
          sourceType: STOCK_CHECK_PRODUCT_LOG_SOURCE_TYPE.WEB_MANUAL,
        };
        const {
          data: { data, message },
        } = await ApiService.put(
          '/v1/stock-check-product/add-product-to-cart',
          body,
        );
        const foundRowUpdated = this.items.find(({ id }) => id === data.id);
        if (foundRowUpdated) {
          foundRowUpdated.version = data.version;
          foundRowUpdated.realQuantity = data.realQuantity;
          foundRowUpdated.realImeiNos = this.convertImeiToString(
            data.realImeiNos,
          );
          foundRowUpdated.stateName = data.stateName;
          foundRowUpdated.stockInfo = data.stockInfo;
        }
        this.$delete(this.pendingChanges, product.id);
        makeToastSuccess(message);
      } catch (error) {
        handleError(error);
        const { status } = error.response;
        if (status === 409) {
          this.retryFetchOnConflict(product);
        }
      }
    },
    async retryFetchOnConflict(stockCheckProduct) {
      const foundIndex = this.items.findIndex(
        (item) => item.id === stockCheckProduct.id,
      );
      if (foundIndex !== -1) {
        const {
          data: { data: newStockCheckProduct },
        } = await ApiService.get(
          `/v1/stock-check-product/${stockCheckProduct.id}`,
        );

        this.$set(this.items, foundIndex, {
          ...newStockCheckProduct,
          realImeiNos: this.convertImeiToString(
            newStockCheckProduct.realImeiNos,
          ),
        });
      }
    },
    handleCategorySelected(categoryId) {
      if (this.isBusy) {
        return;
      }
      this.$router
        .push({
          name: 'upsert-inventory-check',
          query: { id: this.stockCheckSheet.id },
        })
        .catch(() => {});
      this.selectedCategoryId = categoryId;
      this.$route.query.page = 1;
      this.fetchProductByCategory();
    },
    changePlaceholder() {
      if (
        this.selectTypeSearch === STOCK_CHECK_PRODUCT_SEARCH_TYPE.PRODUCT_NAME
      ) {
        this.searchProductImei = '';
        this.inputPlaceHolder = 'Tìm kiếm theo tên, mã, mã vạch sản phẩm';
      } else if (
        this.selectTypeSearch === STOCK_CHECK_PRODUCT_SEARCH_TYPE.PRODUCT_IMEI
      ) {
        this.searchProduct = '';
        this.inputPlaceHolder = 'Tìm kiếm theo mã IMEI sản phẩm';
      } else if (
        this.selectTypeSearch ===
        STOCK_CHECK_PRODUCT_SEARCH_TYPE.BARCODE_SCANNER
      ) {
        this.searchProduct = '';
        this.searchProductImei = '';
        this.inputPlaceHolder = 'Tìm kiếm theo mã vạch hoặc IMEI sản phẩm';
      }
    },
    handleSearchByProductType() {
      if (
        this.selectTypeSearch === STOCK_CHECK_PRODUCT_SEARCH_TYPE.PRODUCT_NAME
      ) {
        this.searchProduct = this.textSearchProduct;
        this.searchProductImei = '';
      } else {
        this.searchProductImei = this.textSearchProduct;
        this.searchProduct = '';
      }
    },
    onFilter() {
      this.$route.query.page = 1;
      this.$router.push({
        name: 'upsert-inventory-check',
      });
      this.fetchProductByCategory();
    },
    getParamsFilter() {
      this.handleSearchByProductType();
      const params = {
        stockCheckCategoryId: this.selectedCategoryId,
        productType: this.stockCheckSheet.productType,
        limit: this.limit,
        page: this.$route.query.page,
        storeId: this.stockCheckSheet.storeId,
        searchImei: this.searchProductImei,
        searchProduct: this.searchProduct,
        orderBy: this.selectTypeFilter,
      };
      return params;
    },
    fetchProductByCategory: async function () {
      try {
        this._snapshotCurrentItems();
        this.dataContent = 'Danh sách sản phẩm';
        this.isBusy = true;
        const params = this.getParamsFilter();
        const response = await ApiService.query('/v1/stock-check-product', {
          params,
        });
        const data = response.data?.data || [];
        this.totalItem = data.totalRow || 0;
        this.numberOfPage = data.totalPage || 1;
        // Nếu máy quét mã vạch search ra đúng IMEI tự động gọi API kiểm kê
        const isScanImei = this.isScanBarcodeScanner();
        const shouldAutoFillImei =
          this.selectTypeSearch ===
            STOCK_CHECK_PRODUCT_SEARCH_TYPE.PRODUCT_IMEI &&
          this.stockCheckSheetData.status === STOCK_CHECK_SHEET_STATUS.NEW;

        this.items = this.mappingStockCheckProductRes(data.dataset);
        this.items = this.items.map((item) => {
          const pending = this.pendingChanges[item.id];
          if (!pending) return item;
          return { ...item, realQuantity: pending.realQuantity, realImeiNos: pending.realImeiNos };
        });

        if (this.totalItem === 1 && (isScanImei || shouldAutoFillImei)) {
          // nếu scan nhanh bằng máy bắn code thì clear text search để bắn code tiếp
          if (isScanImei) {
            this.textSearchProduct = '';
          }

          const stockCheckProduct = data.dataset[0];
          const foundImei = stockCheckProduct.imeiNos?.find(
            (imeiNo) => imeiNo === this.searchProductImei,
          );
          if (foundImei) {
            // Đồng bộ SL theo số IMEI thực nhập (không tính dòng rỗng)
            const currentImeis = Array.isArray(stockCheckProduct.realImeiNos)
              ? stockCheckProduct.realImeiNos
              : String(stockCheckProduct.realImeiNos || '')
                  .split(/\r\n|\r|\n|,/)
                  .map((x) => x.trim())
                  .filter(Boolean);
            const nextImeis = currentImeis.concat(foundImei);
            stockCheckProduct.realImeiNos = nextImeis.join(', ');
            stockCheckProduct.realQuantity = nextImeis.filter(
              (x) => String(x).trim() !== '',
            ).length;
            await this.upsertStockCheckProduct(stockCheckProduct);
            this.textSearchProduct = '';
          }
        }
      } catch (err) {
        handleError(err);
      } finally {
        this.isBusy = false;
      }
    },
    isScanBarcodeScanner() {
      return (
        this.totalItem === 1 &&
        this.selectTypeSearch ===
          STOCK_CHECK_PRODUCT_SEARCH_TYPE.BARCODE_SCANNER &&
        !this.isConfirmed
      );
    },
    onInputChangeProduct() {
      this.$route.query.page = 1;
      this.debounceInputProduct();
    },
    debounceInputProduct: debounce(function () {
      this.fetchProductByCategory();
    }, TIME_TRIGGER),
    mappingStockCheckProductRes(stockCheckProducts = []) {
      return stockCheckProducts.map((product, index) => {
        return {
          index: index + 1,
          ...product,
          realQuantity: product.realQuantity || 0,
          productType: product.productType,
          realImeiNos: this.convertImeiToString(product.realImeiNos),
        };
      });
    },
    convertImeiToString(realImeiNos) {
      if (!realImeiNos) return '';
      if (typeof realImeiNos === 'string') return realImeiNos;
      return realImeiNos.join(', \n');
    },
    getClassForImei(imeiNo, realImeiNos) {
      return realImeiNos.includes(imeiNo) ? 'text-success' : 'text-danger';
    },
    getDisplayedImeis(item) {
      const isExpanded = this.expandedImeiRows[item.id];
      return isExpanded ? item.imeiNos : item.imeiNos.slice(0, 3);
    },
    toggleImeiVisibility(index) {
      const item = this.items[index];
      this.$set(
        this.expandedImeiRows,
        item.id,
        !this.expandedImeiRows[item.id],
      );
      this.forceUpdate++;
    },
    isImeiExpanded(index) {
      const item = this.items[index];
      return this.expandedImeiRows[item.id];
    },
    showNoteModal(item) {
      this.$refs['note-modal'].showModal(item);
    },
    handleNoteSaved({ id, note }) {
      const found = this.items.find((item) => item.id === id);
      if (found) {
        found.note = note;
      }
    },
  },
  components: {
    Categories,
    InventoryCheckHistory,
    InventoryCheckNoteModal,
    BPaginationNavCustom,
    vclTable,
    ProductImage,
  },
  computed: {
    fieldsComputed() {
      return this.fields;
    },
  },
};
</script>

<style scoped>
.scrollable-cell {
  height: 100px;
  overflow-y: auto;
}

.item {
  padding: 5px;
  border-bottom: 1px solid #ccc;
}

.btn-cart {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 30px;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  color: #007bff !important;
}

/* Header styling */
.table th {
  vertical-align: middle;
  padding: 0.75rem 0.5rem;
}

.table th .d-flex {
  align-items: center;
}

.icon-style {
  font-size: 22px;
  color: #3699ff;
}

.imei-input-container {
  position: relative;
}

.imei-textarea {
  border: 1px solid #007bff;
  border-radius: 4px;
  font-size: 0.85rem;
  line-height: 1.3;
  resize: none;
}

.imei-textarea:focus {
  border-color: #0056b3;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.imei-system-container {
  max-height: 80px;
  overflow-y: auto;
  font-size: 0.85rem;
}

.imei-item {
  padding: 2px 4px;
  margin: 1px 0;
  border-radius: 3px;
  font-size: 0.8rem;
  word-break: break-all;
}

.imei-item.text-success {
  background-color: #d4edda;
  color: #155724;
}

.imei-item.text-danger {
  background-color: #f8d7da;
  color: #721c24;
}

.sticky-action-bar {
  position: sticky;
  bottom: 0;
  z-index: 10;
  background: #fff;
  padding: 12px 0 8px;
  border-top: 1px solid #e9ecef;
  margin-top: 8px;
}
</style>
